import React from 'react';
import { Route } from 'react-router-dom';
import Roles from '../pages/roles/Roles';
import CreateRoles from '../pages/roles/CreateRoles';
import EditRoles from '../pages/roles/EditRoles';
import PermissionGuard from '../components/global/PermissionGuard';

const rolesRoutes = (
    <>
        <Route
            path="/roles"
            element={
                <PermissionGuard permission="roles_list">
                    <Roles />
                </PermissionGuard>
            }
        />

        <Route
            path="/roles/create"
            element={
                <PermissionGuard permission="roles_create">
                    <CreateRoles />
                </PermissionGuard>
            }
        />

        <Route
            path="/roles/:id/edit"
            element={
                <PermissionGuard permission="roles_edit">
                    <EditRoles />
                </PermissionGuard>
            }
        />
    </>
);

export default rolesRoutes;
